// @core/api/endpoints/project/remove_project_member.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/project';

/**
 * Remove project member
 * Removes a member from the project, revoking their access. Items assigned to the removed member remain but may need reassignment.
 */
export async function RemoveProjectMember(
  project_id: string,
  profile_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/members/:profile_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
